const resultsInput = {
  en: {
    resultsInputPage: {
      backOnline: "Back online!",
      syncingPending: "Syncing pending results...",
      youAreOffline: "You are offline",
      savedLocally: "Results will be saved locally.",
      syncingCount: "Syncing {{count}} pending result(s)...",
      synced: "Synced: {{location}}",
      correctionLoaded: "Correction loaded. Please review and update the data, then submit.",
      fillRequired: "Please fill in all required fields",
      regionalOnly: "Regional elections only apply to North-West and South-West regions",
      savedOffline: "Result saved offline!",
      savedOfflineDesc: "Will sync automatically when back online.",
      autoApproved: "Result auto-approved! (3rd submission attempt - approval bypassed)",
      correctionSubmitted: "Correction submitted (Attempt {{attempt}}/3). Awaiting verification.",
      submitted: "Result submitted successfully! Awaiting verification.",
      networkErrorOffline: "Network error - saved offline",
      networkErrorOfflineDesc: "Will sync when connection is restored.",
      submitFailed: "Failed to submit result",
      offlineTitle: "You are offline",
      pendingSync: "{{count}} result(s) pending sync",
      offlineDesc: "Results will be saved locally and synced when you reconnect.",
      pendingDesc: "These will sync automatically when you have a stable connection.",
      syncNow: "Sync Now",
      title: "Submit Election Results",
      subtitle: "Enter polling station results",
      offlineMode: "Offline Mode",
      needCorrection: "Results Need Correction",
      needCorrectionDesc: "You have {{count}} result(s) that require correction. Please address these before submitting new results.",
      attempt: "Attempt {{attempt}}/3",
      reviewerComments: "Reviewer Comments:",
      reviewed: "Reviewed: {{date}}",
      autoApproveWarning: "Next submission will be auto-approved (bypass verification)",
      oneMoreRejection: "One more rejection will trigger auto-approval",
      editResubmit: "Edit & Resubmit",
      editingCorrection: "Editing Correction",
      resubmitting: "Resubmitting: {{name}} ({{region}}) - Attempt {{attempt}}/3",
      cancelEdit: "Cancel Edit",
      electionDetails: "Election Details",
      electionTypeLabel: "Election Type *",
      selectElectionType: "Select election type",
      regionalNote: "Note: Regional elections only apply to North-West and South-West regions",
      regionLabel: "Region *",
      selectRegion: "Select region",
      divisionLabel: "Division *",
      selectDivision: "Select division",
      subdivisionLabel: "Subdivision",
      selectSubdivision: "Select subdivision",
      pollingStationName: "Polling Station Name *",
      pollingStationPlaceholder: "e.g., Government School Bamenda",
      voteCounts: "Vote Counts",
      registeredVoters: "Registered Voters",
      totalVotesCast: "Total Votes Cast",
      validVotes: "Valid Votes",
      rejectedVotes: "Rejected Votes",
      votesPerCandidate: "Votes per Candidate",
      photoAndNotes: "Result Sheet Photo & Notes",
      uploadPhoto: "Upload Result Sheet Photo",
      previewAlt: "Result sheet preview",
      clickToUpload: "Click to upload or drag and drop",
      fileHint: "PNG, JPG up to 10MB",
      additionalNotes: "Additional Notes",
      notesPlaceholder: "Any observations or irregularities...",
      cancel: "Cancel",
      submitting: "Submitting...",
      submitResult: "Submit Result",
      electionTypes: {
        presidential: "Presidential Election",
        parliamentary: "Parliamentary Elections",
        senatorial: "Senatorial Elections",
        regional: "Regional Elections",
        council: "Council Elections"
      },
      shortElectionTypes: {
        presidential: "presidential", parliamentary: "parliamentary", senatorial: "senatorial",
        regional: "regional", council: "council"
      },
      statuses: { correction_requested: "correction requested", rejected: "rejected", pending: "pending", disputed: "disputed" }
    }
  },
  fr: {
    resultsInputPage: {
      backOnline: "De retour en ligne !",
      syncingPending: "Synchronisation des résultats en attente...",
      youAreOffline: "Vous êtes hors ligne",
      savedLocally: "Les résultats seront enregistrés localement.",
      syncingCount: "Synchronisation de {{count}} résultat(s) en attente...",
      synced: "Synchronisé : {{location}}",
      correctionLoaded: "Correction chargée. Veuillez vérifier et mettre à jour les données, puis soumettre.",
      fillRequired: "Veuillez remplir tous les champs obligatoires",
      regionalOnly: "Les élections régionales ne concernent que les régions du Nord-Ouest et du Sud-Ouest",
      savedOffline: "Résultat enregistré hors ligne !",
      savedOfflineDesc: "Il sera synchronisé automatiquement au retour de la connexion.",
      autoApproved: "Résultat approuvé automatiquement ! (3e tentative de soumission - approbation contournée)",
      correctionSubmitted: "Correction soumise (tentative {{attempt}}/3). En attente de vérification.",
      submitted: "Résultat soumis avec succès ! En attente de vérification.",
      networkErrorOffline: "Erreur réseau - enregistré hors ligne",
      networkErrorOfflineDesc: "Il sera synchronisé dès que la connexion sera rétablie.",
      submitFailed: "Échec de la soumission du résultat",
      offlineTitle: "Vous êtes hors ligne",
      pendingSync: "{{count}} résultat(s) en attente de synchronisation",
      offlineDesc: "Les résultats seront enregistrés localement et synchronisés à votre reconnexion.",
      pendingDesc: "Ils seront synchronisés automatiquement dès que vous aurez une connexion stable.",
      syncNow: "Synchroniser maintenant",
      title: "Soumettre les résultats électoraux",
      subtitle: "Saisissez les résultats du bureau de vote",
      offlineMode: "Mode hors ligne",
      needCorrection: "Des résultats nécessitent une correction",
      needCorrectionDesc: "Vous avez {{count}} résultat(s) nécessitant une correction. Veuillez les traiter avant de soumettre de nouveaux résultats.",
      attempt: "Tentative {{attempt}}/3",
      reviewerComments: "Commentaires du vérificateur :",
      reviewed: "Examiné le : {{date}}",
      autoApproveWarning: "La prochaine soumission sera approuvée automatiquement (vérification contournée)",
      oneMoreRejection: "Un rejet supplémentaire déclenchera l'approbation automatique",
      editResubmit: "Modifier et soumettre à nouveau",
      editingCorrection: "Modification d'une correction",
      resubmitting: "Nouvelle soumission : {{name}} ({{region}}) - Tentative {{attempt}}/3",
      cancelEdit: "Annuler la modification",
      electionDetails: "Détails de l'élection",
      electionTypeLabel: "Type d'élection *",
      selectElectionType: "Sélectionnez le type d'élection",
      regionalNote: "Remarque : les élections régionales ne concernent que les régions du Nord-Ouest et du Sud-Ouest",
      regionLabel: "Région *",
      selectRegion: "Sélectionnez la région",
      divisionLabel: "Département *",
      selectDivision: "Sélectionnez le département",
      subdivisionLabel: "Arrondissement",
      selectSubdivision: "Sélectionnez l'arrondissement",
      pollingStationName: "Nom du bureau de vote *",
      pollingStationPlaceholder: "p. ex. École publique de Bamenda",
      voteCounts: "Décompte des votes",
      registeredVoters: "Électeurs inscrits",
      totalVotesCast: "Total des votes exprimés",
      validVotes: "Votes valides",
      rejectedVotes: "Votes rejetés",
      votesPerCandidate: "Votes par candidat",
      photoAndNotes: "Photo du procès-verbal et notes",
      uploadPhoto: "Téléverser la photo du procès-verbal",
      previewAlt: "Aperçu du procès-verbal",
      clickToUpload: "Cliquez pour téléverser ou glissez-déposez",
      fileHint: "PNG, JPG jusqu'à 10 Mo",
      additionalNotes: "Notes supplémentaires",
      notesPlaceholder: "Observations ou irrégularités éventuelles...",
      cancel: "Annuler",
      submitting: "Soumission en cours...",
      submitResult: "Soumettre le résultat",
      electionTypes: {
        presidential: "Élection présidentielle",
        parliamentary: "Élections législatives",
        senatorial: "Élections sénatoriales",
        regional: "Élections régionales",
        council: "Élections municipales"
      },
      shortElectionTypes: {
        presidential: "présidentielle", parliamentary: "législative", senatorial: "sénatoriale",
        regional: "régionale", council: "municipale"
      },
      statuses: { correction_requested: "correction demandée", rejected: "rejeté", pending: "en attente", disputed: "contesté" }
    }
  }
};

export default resultsInput;
